import { liveFormInputSelectors } from 'state/secondaryMarket/live/form/input/inputForm.selectors';
import type { AppState } from 'state/state.model';

export function computeSalesAdjustedPrice(state: AppState, tabId: string, price?: number): number | undefined {
  const salesMarginAdj = liveFormInputSelectors.getFormInputCustomizedXMarginAdjustment(state, tabId) ?? 0;
  const tradingPriceAdj = liveFormInputSelectors.getFormInputCustomizedTradingPriceAdjustment(state, tabId) ?? 0;

  if (price !== undefined) {
    return salesMarginAdj + price + tradingPriceAdj;
  }
  return undefined;
}
